// TECH-DEBT: co-location candidate — only imported by
// components/shared/DemoPortfolioButton.tsx; consider co-locating with that component.
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { createDemoPortfolio } from "@/api/client";
import { usePortfolio } from "@/contexts/PortfolioContext";
import { useT } from "@/lib/translation";

/**
 * Creates the demo portfolio if needed (the backend returns the existing one otherwise) and
 * selects it. By default it then opens the dashboard. `stayOnPage` keeps the user where they
 * are, for trying a paid feature on the demo from its own page.
 */
export function useExploreDemo({
  stayOnPage = false,
}: { stayOnPage?: boolean } = {}) {
  const [isDemoLoading, setIsDemoLoading] = useState(false);
  const { refetchPortfolios, setSelectedPortfolioId } = usePortfolio();
  const navigate = useNavigate();
  const t = useT();

  const handleExploreDemo = async () => {
    setIsDemoLoading(true);
    try {
      const demo = await createDemoPortfolio();
      await refetchPortfolios();
      setSelectedPortfolioId(demo.id);
      if (!stayOnPage) navigate("/portfolio/dashboard");
    } catch (err) {
      console.error("Failed to load demo portfolio", err);
      toast.error(t("common:demoPortfolioButton.loadFailed"));
    } finally {
      setIsDemoLoading(false);
    }
  };

  return { handleExploreDemo, isDemoLoading };
}
